import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import { formatDate, FORMAT_DATE_BACK, isEmpty, postSubmit, scrollToComponent, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { useStockChangesRoleConfig } from "../../@hooks"
import { StockChangesPriceEvolutionFilters } from "../../@signals"


export default function useStockChangesPriceEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApiPriceEvolution } = useStockChangesRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
	const retailer = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
	const currency = useSignal("")
	const evolutionDatePeriod = useSignal(DATE_PERIODS.LAST_7_DAYS)
	const dateRange = useSignal([])

    useEffect(() => {
		if (!isEmpty(StockChangesPriceEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(urlApiPriceEvolution, StockChangesPriceEvolutionFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				chartColors.value = res.chartColors
				skuName.value = res.skuName
				currency.value = res.currency
				retailer.value = res.retailer
				dateRange.value = [stringToDate(StockChangesPriceEvolutionFilters.value.startDate), stringToDate(StockChangesPriceEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-price-chart')))
		}) 

		if (isEmpty(StockChangesPriceEvolutionFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			chartColors.value = {}
			skuName.value = ""
			currency.value = ""
			retailer.value = ""
			evolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
		})

	}, [JSON.stringify(StockChangesPriceEvolutionFilters.value)])
	
	const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		skuName.value = ""
		retailer.value = ""
		currency.value = ""
		StockChangesPriceEvolutionFilters.value = {}
		evolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
	})

	const handleChangeEvolutionPeriod = (e) => {
		batch(() => {
			dateRange.value = e
			StockChangesPriceEvolutionFilters.value = {
				...StockChangesPriceEvolutionFilters.value,
				startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK })
			}
		})
	}

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		currency: currency.value,
		skuName: skuName.value,
		evolutionDatePeriod: evolutionDatePeriod.value,
		chartColors: chartColors.value,
		retailer: retailer.value,
		dateRange: dateRange.value,

        resetEvolutionData,
		handleChangeEvolutionPeriod
	}
}